export class ContactLawyer {

	id: number = 0
	name: string = ""
	surname: string = ""
	email: string = ""
	phone: string = ""
	position: string = ""
	id_lawyer: number = 0

	constructor (data?) {
		this.setId ((typeof data != "undefined" && typeof data.id != "undefined") ? data.id : 0 )
		this.setName ((typeof data != "undefined" && typeof data.name != "undefined") ? data.name : '' )
		this.setSurname ((typeof data != "undefined" && typeof data.surname != "undefined") ? data.surname : '' )
		this.setEmail ((typeof data != "undefined" && typeof data.email != "undefined") ? data.email : '' )
		this.setPhone ((typeof data != "undefined" && typeof data.phone != "undefined") ? data.phone : '' )
		this.setPosition ((typeof data != "undefined" && typeof data.position != "undefined") ? data.position : '' )
		this.setIdLawyer ((typeof data != "undefined" && typeof data.id_lawyer != "undefined") ? data.id_lawyer : 0 )
	}

	setId (id: number = 0) { this.id = id }
	setName (name: string = "") { this.name = name }
	setSurname (surname: string = "") { this.surname = surname }
	setEmail (email: string = "") { this.email = email }
	setPhone (phone: string = "") { this.phone = phone }
	setPosition (position: string = "") { this.position = position }
	setIdLawyer (id: number = 0) { this.id_lawyer = id }

	getId () { return this.id }
	getName () { return this.name }
	getSurname () { return this.surname }
	getEmail () { return this.email }
	getPhone () { return this.phone }
	getPosition () { return this.position }
	getIdLawyer () { return this.id_lawyer }

	toArray () {
		return {
			id: this.getId (),
			name: this.getName (),
			surname: this.getSurname (),
			email: this.getEmail (),
			phone: this.getPhone (),
			position: this.getPosition (),
			id_lawyer: this.getIdLawyer (),
		}
	}

	toJson () {
		return JSON.stringify (this.toArray ())
	}

}